import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";
import { bookingCityUrl, cityShort, rememberCity } from "@/lib/bookingCity";

type Props = {
  city: string;
  campaign: string;
  /** Where on the page this CTA sits — used as an analytics dimension. */
  placement: string;
  children: React.ReactNode;
  studio?: string;
  className?: string;
  variant?: "default" | "outline";
};

/**
 * Landing-page "Check availability" CTA. Fires a `landing_cta_click` analytics
 * event tagged with the city/location, then deep-links into the booking flow's
 * live availability calendar with the city pre-filled.
 */
export const CheckAvailabilityCta = ({
  city,
  campaign,
  placement,
  children,
  studio,
  className,
  variant = "default",
}: Props) => {
  const to = bookingCityUrl(city, { campaign, studio });
  return (
    <Link
      to={to}
      onClick={() => {
        rememberCity(city);
        trackEvent("landing_cta_click", {
          city,
          city_label: cityShort(city) ?? city,
          campaign,
          placement,
          destination: to,
          page_path: typeof window !== "undefined" ? window.location.pathname : undefined,
        });
      }}
    >
      <Button
        variant={variant === "outline" ? "outline" : undefined}
        className={
          className ??
          (variant === "outline"
            ? "border-border font-body px-8"
            : "bg-primary text-primary-foreground hover:bg-primary/90 font-body font-semibold px-8")
        }
      >
        {children}
      </Button>
    </Link>
  );
};

export default CheckAvailabilityCta;